import React from 'react';

import ScrollableList from '../ScrollableList';

import * as style from './style.module.css';

const ButtonsContainer = ({ children, position = 'LEFT', scrollable = true, noMargin = false, shadowHeight, className = '' }) => {
  const computedClassName = `${style.buttonContainer} ${position === 'RIGHT' ? style.right : position === 'CENTER' ? style.center : ''} ${noMargin ? style.noMargin : ''} ${className}`;
  
  if (scrollable) {
    return (
      <ScrollableList shadow="var(--comp-card-background-color)" shadowHeight={shadowHeight} className={computedClassName}>
        {children}
      </ScrollableList>
    );
  }
  return <div className={computedClassName}><div>{children}</div></div>;
};

export default React.memo(ButtonsContainer);
